import * as React from 'react';

var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgUnsupported = function SvgUnsupported(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 120"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "m60 0 52 30v60l-52 30L8 90V30z",
        clipRule: "evenodd"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "#6B6580",
        fillRule: "evenodd",
        d: "M60 56.812 11.272 29 9 32.892 60 62l51-29.108L108.729 29z",
        clipRule: "evenodd"
    })), _path3 || (_path3 = /*#__PURE__*/ React.createElement("path", {
        fill: "#6B6580",
        fillRule: "evenodd",
        d: "M63 60v58h-6V60z",
        clipRule: "evenodd"
    })), _path4 || (_path4 = /*#__PURE__*/ React.createElement("path", {
        fill: "#6B6580",
        fillRule: "evenodd",
        d: "m60 0 52 30v60l-52 30L8 90V30zM12.532 32.616v54.768L60 114.77l47.468-27.385V32.616L60 5.23z",
        clipRule: "evenodd"
    })), _path5 || (_path5 = /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M100 60c0 22.091-17.909 40-40 40S20 82.091 20 60s17.909-40 40-40 40 17.909 40 40"
    })), _path6 || (_path6 = /*#__PURE__*/ React.createElement("path", {
        fill: "#6B6580",
        fillRule: "evenodd",
        d: "m45.282 41.04 33.679 33.678c7.327-9.415 6.664-23.034-1.99-31.689-8.655-8.654-22.274-9.317-31.689-1.99m29.436 37.92L41.039 45.283c-7.327 9.415-6.664 23.034 1.99 31.689 8.655 8.654 22.274 9.317 31.689 1.99M38.787 38.788c11.715-11.716 30.71-11.716 42.426 0s11.716 30.71 0 42.426-30.71 11.716-42.426 0-11.716-30.71 0-42.426",
        clipRule: "evenodd"
    })));
};

export { SvgUnsupported as ReactComponent };
//# sourceMappingURL=Unsupported.svg.es.js.map
